// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pj-0";
export var animationContainer = "_pj-1";
export var itemPrice = "_pj-a";
export var itemizedContent = "_pj-9";
export var itemizedHeader = "_pj-7";
export var itemizedRow = "_pj-8";
export var itemizedSection = "_pj-6";
export var modalContent = "_pj-2";
export var orderName = "_pj-3";
export var refundOption = "_pj-4";
export var refundOptionsContainer = "_pj-5";
export var shippingLabel = "_pj-b";
export var totalRow = "_pj-c";